module.exports = __webpack_public_path__ + "static/media/upload-accent.12ff26f2.svg";